<div class="info-item">
  <span [ngStyle]="labelStyles | theme">
    {{ config().label }}
  </span>
  <div class="info-item__value-container">
    @if (config().showPulse) {
      <span class="info-item__pulse"></span>
    }
    <span [ngStyle]="valueStyles | theme">
      {{ config().value }}
    </span>
  </div>
</div>
